<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size sm_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.ADMIN.EXTENDED.PERIOD') }}</i>
                </dt>
                <dd>
                    <div class="Select_wrap">
                        <ul class="txt_sel">
                            <li class="tit">{{ $t('FIELD.GLOBAL.PERIOD') }}</li>
                            <li data-input-type="select" class="w60">
                                <select class="slt_white w100" v-model="searchRemainingPeriod">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option value="7">{{ $t('FIELD.GLOBAL.1.WEEK') }}</option>
                                    <option value="30">{{ $t('FIELD.GLOBAL.1.MONTH') }}</option>
                                    <option value="90">{{ $t('FIELD.GLOBAL.3.MONTH') }}</option>
                                </select>
                            </li>
                        </ul>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnExtended">{{ $t('BUTTON.GLOBAL.EXTENDED') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import axios                    from 'axios';
import qs                       from 'query-string';
import store                    from '@/vuex/store';
import { SDLUtil, StringUtil }  from '@/utils';

export default {
    name: 'ExtendedPeriodPopup',
    props: {
        knowledgeId:  { default: [] },
        rtnFunc:      { type: Function }
    },
    data() {
        return {
            searchRemainingPeriod: ''
        }
    },
    methods: {
        btnExtended() {
            SDLUtil.confirm({
                title: 'BUTTON.GLOBAL.CONFIRM',
                msg: 'MESSAGE.DATA.EXECUTE.CONFIRM',
                onOkEvt: () => {
                    let params = { knowledgeList: this.knowledgeId, period: this.searchRemainingPeriod };
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/admin/knowledgeManager/expiringKnowledge/ExpiringKnowledgeExtended.skp`,
                                qs.stringify(params),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Expire Knowledge details
                                            this.rtnFunc();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        }
    }
};

</script>
<style>
/* with admin css */
.Select_wrap { position: relative; padding: 11px 10px; background-color: #f7f7f7; margin-top: 20px; }

.txt_sel { width: 100%; display: inline-block; }
.txt_sel li { float: left; padding: 5px 0; }
.txt_sel .tit { width: 130px; padding: 12px 0 0 20px; }

.w60 { width: 60% !important; }
.w100 { width: 100% !important; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/expiringKnowledge/popup/ExtendedPeriodPopup.vue